import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

export function createOrUpdateNotificationSetting(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/notificationSetting/createOrUpdate`, data, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPageNotifications(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/notification/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPageCustomNotifications(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/customNotification/getAllNotifications`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function countCustomNotificationList(userId, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/customNotification/countAllNotifications`,
            filterRequest,
            {
                params: {
                    userId,
                },
            },
        )
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function readOrDiscard(userId, id, status = 'read') {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/notification/readOrDiscard`, null, {
            params: {userId, id, status},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getByUserId(userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/notificationSetting/getByUserId`, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function sendPushNotification(data, userId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/watch/sendPushNotification`, data, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function clearAllNotifications(userId, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/notification/discardAll`, filterRequest, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
